(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quick-customize"] && !Shopify.designMode) return;
  try {
    // Check if we should auto-open the configurator (coming from collection page)
  document.addEventListener('DOMContentLoaded', () => {
    const shouldOpenConfigurator = localStorage.getItem('hb-open-customizer');
    if (shouldOpenConfigurator) {
      const collectionUrl = localStorage.getItem('hb-collection-url');
      localStorage.removeItem('hb-open-customizer');
      
      // Store collection URL as referrer so we can go back to it
      if (collectionUrl) {
        try {
          localStorage.setItem('hb-customizer-referrer', collectionUrl);
        } catch (e) {}
      }
      
      // Small delay to ensure modal is fully loaded
      setTimeout(() => {
        const modal = document.querySelector('#bookery-modal');
        if (modal) {
          modal.classList.add('bookery-modal--open');
          document.body.classList.add('bookery-customizer-active');
          window.scrollTo(0, 0);
          window.dispatchEvent(new Event('bookery-modal-open'));
        }
      }, 100);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
